<div class="row m-0 available-activities">
  <div class="col-lg-3 col-md-4 p-0">
    <div class="reservation-filter-layout">
      <app-activity-filter (filterData)="loadClassActivities($event)" (resetData)="assignResetData($event)">
      </app-activity-filter>
    </div>
  </div>
  <div class="col-lg-9 col-md-8 p-0">
    <div class="banner-scrool">
      @if (!activityService.hideImage) {
        <div class="activity__banner-image" [ngClass]="{'layout__banner-image-height':activityService.hideImage}">
          <img src="{{activityService.imageUrl}}"  (error)="activityService.loadDefaultImage($event)" alt="banner-img" >
        </div>
      }
      <div class="activity-selector column">
        <div class="row m-0">
          <div class="col-lg-6 col-md-6 p-0">

            <div class="actvity-sub-title">
              {{'SelectanavailableClass' | translate}}
            </div>
          </div>

          <div class=" col-lg-6 col-md-6 row">
            <div class="col-lg-4 col-md-4 grid-view"> <span class="icon-grid1"
            [ngClass]="{'active':isListView !== true }" (click)="changeView(false)"></span> <span
            class="icon-view-list" [ngClass]="{'active':isListView === true }"
          (click)="changeView(true)"> </span></div>

          <div class="search-filter col-lg-8 col-md-8 pe-0">
            <dynamic-form [config]="search_config" #form="dynamicForm">
            </dynamic-form>
          </div>
        </div>
        @if (availableActivities.length > 0;) {
          @if (!isListView) {
            <div class="col-lg-12 col-md-12">
              <div class="legends">
                <div class="legends-list">
                  <span class="dot">
                    &nbsp;
                  </span>
                  {{ 'NotAvailable' | translate }}
                </div>
                <div class="legends-list">
                  <span class="dot"> &nbsp;
                  </span>
                  {{ 'available' | translate }}
                </div>
              </div>
            </div>
          }
        }
      </div>
      @if (availableActivities.length > 0) {
        @if (!isListView) {
          <div>
            <div class="avail-container">
              @for (class of availableActivities; track class; let index = $index) {
                <div class="activity-box"
                  [ngStyle]="class.Color != null ?{'border':'3px solid rgba('+class.Color.R+','+class.Color.G+','+class.Color.B+','+class.Color.A+')'}: ''"
                  (click)="selectedClassActivity(class)"
                  [ngClass]="{'slot-disabled' : class.Availability === 'Not Available'}">
                  <div class="title ellipsis-text" title="{{class.LessonName}}">
                    {{class.LessonName}}
                  </div>
                  <div class="location ellipsis-text" title="{{class.LocationName}}">
                    {{class.LocationName}}
                  </div>
                  <div class="available">
                    {{class.Availability}}
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (isListView) {
          <div class="table-container">
            <mat-table [dataSource]="filterDataGridList" class="list-container" matSort matSortDisableClear>
              @for (column of cols; track column; let i = $index) {
                <ng-container matColumnDef="{{column.field}}">
                  <th  mat-header-cell *matHeaderCellDef class="table-header pt-2"
                    [style.width]="column.style.width" [hidden]="!column.availability">
                    {{column.header | translate}}
                    <!-- <span class="fa fa-sort"></span> -->
                  </th>
                  <td mat-cell *matCellDef="let element" [style.width]="column.style.width" [hidden]="!column.availability"
                    [class.alignRight]="column.alignRight" [class.alignCenter]="$any(column).alignCenter" >
                    @if (column.isDate) {
                      <span title="{{element[column.field]}}">{{element[column.field] |
                      date:'MM/dd/yyyy'}}</span>
                    }
                    @if (!column.isDate && !column.isCurrency) {
                      <span title="{{element[column.field]}}"
                      >{{element[column.field]}}</span>
                    }
                    @if (column.isCurrency && element[column.field]) {
                      <span title="{{element[column.field]}}"
                      >{{activityService.OperationCurrency}}{{element[column.field]| currencyDecimalFormatter}}</span>
                    }
                    @if (column.isCurrency && !element[column.field]) {
                      <span title="{{element[column.field]}}"
                      >{{activityService.OperationCurrency}}{{ 0 | currencyDecimalFormatter}}</span>
                    }
                  </td>
                </ng-container>
              }
              <mat-header-row *matHeaderRowDef=" columnsToDisplay"></mat-header-row>
              <mat-row *matRowDef="let row; columns: columnsToDisplay; let index = index;"
                [ngClass]="row['Availability'] === 'Available'? 'cursor-pointer': 'cursor-blocked'"
                (click)="selectedItem(row, index)">
              </mat-row>
            </mat-table>
            @if (filterDataGridList && !filterDataGridList.filteredData.length) {
              <div class="no-records row">
              {{'Noclassavailable' | translate}}</div>
            }
          </div>
        }
      } @else {
        <p class="no-avail">{{'Noclassavailable' | translate}}</p>
      }
    </div>
  </div>
</div>
</div>